import React from 'react';
import styles from './Account.module.scss'
import AccountDetails from "../../../components/AccountDetails/AccountDetails";
import LoginsManager from "../../../components/LoginsManager/LoginsManager";
import AccountUsersTable from "../../../components/AccountUsersTable/AccountUsersTable";


const AdminAccount = () => {
    return (
        <>
            <div className={styles['flex-row']}>
                <div className={styles['col']}>
                    <div className={styles['box']}>
                        <AccountDetails/>
                    </div>
                </div>
                <div className={styles['col']}>
                    <div className={styles['box']}>
                        <LoginsManager className={styles['box']}/>
                    </div>
                </div>
            </div>
            <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <AccountUsersTable/>
                    </div>
            </div>
        </>
    )
}

export default AdminAccount;
